import EmpManage from './empManage.vue'
import Add from './add/add-routing'

export default [{
    path: '/lyEmpManage',
    name:'lyEmpManage',
    component:EmpManage,
    children:[...Add]
}]